import { render, staticRenderFns } from "./T3.vue?vue&type=template&id=30de8b06"
import script from "./T3.vue?vue&type=script&lang=ts"
export * from "./T3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports